import React from 'react';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, itemName }) => {
    if (!isOpen) return null;

    return (
        <>
            {/* Overlay */}
            <div
                className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[110] transition-opacity animate-fadeIn"
                onClick={onClose}
            />

            {/* Modal */}
            <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] bg-white rounded-[40px] shadow-2xl z-[111] overflow-hidden animate-zoomIn p-10 font-jakarta">
                <div className="flex flex-col items-center text-center">
                    {/* Trash/Exclamation Icon */}
                    <div className="w-24 h-24 bg-[#FF7171] rounded-full flex items-center justify-center mb-6 shadow-lg shadow-red-100">
                        <span className="text-white text-6xl font-bold">!</span>
                    </div>

                    {/* Content */}
                    <h3 className="text-[28px] font-bold text-[#1E293B] mb-2">Anda Yakin?</h3>
                    <p className="text-[#64748B] text-base mb-10 leading-relaxed px-2">
                        Apakah anda yakin ingin menghapus <span className="font-bold text-[#1E293B]">{itemName || 'item ini'}</span>? Tindakan ini tidak dapat dibatalkan.
                    </p>

                    {/* Buttons */}
                    <div className="w-full space-y-3">
                        <button
                            onClick={() => {
                                onConfirm();
                                onClose();
                            }}
                            className="w-full py-4 bg-[#FF7171] hover:bg-[#FF5C5C] text-white font-bold rounded-2xl shadow-lg shadow-red-200 transition-all flex items-center justify-center active:scale-[0.98]"
                        >
                            Ya, Hapus
                        </button>
                        <button
                            onClick={onClose}
                            className="w-full py-4 bg-white border border-[#F1F5F9] text-[#64748B] font-bold rounded-2xl hover:bg-gray-50 transition-all active:scale-[0.98]"
                        >
                            Tidak
                        </button>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes zoomIn {
                    from {
                        opacity: 0;
                        transform: translate(-50%, -45%) scale(0.95);
                    }
                    to {
                        opacity: 1;
                        transform: translate(-50%, -50%) scale(1);
                    }
                }

                .animate-fadeIn {
                    animation: fadeIn 0.3s ease-out forwards;
                }

                .animate-zoomIn {
                    animation: zoomIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
                }
            `}</style>
        </>
    );
};

export default DeleteConfirmationModal;
